$(window).on('scroll', function () {
  // 各要素の高さを計算
  var form_h = $('.product-form__input').outerHeight(true) || 0;
  var buttons_h = $('.cart_buttons').outerHeight(true) || 0;
  var mesage_h = $('.limit_message').outerHeight(true) || 0;
  var order_h = $('.order_limit_message').outerHeight(true) || 0;
  var margin_h = form_h + buttons_h + order_h + mesage_h + 'px';
  console.log(margin_h);

  // スクロール位置を取得
  scroll = $(window).scrollTop();

  // CSS変数に高さを設定
  document.documentElement.style.setProperty('--total-elements-height', margin_h);

  // ビューポートの高さを取得
  var winH = $(window).height();
  // .product_snsの位置を取得
  var objTop = $('.product_sns').offset().top;

  // .product_snsがビューポートの上部外に出たかどうかをチェック
  if (scroll > objTop + $('.product_sns').outerHeight(true)) {
    $('.cart_buttons').addClass('move');
    $('.product-form__input').addClass('move');
    $('.product_sns').addClass('move');
    $('.limit_message').addClass('move');
    $('.order_limit_message').addClass('move');
  } else {
    $('.cart_buttons').removeClass('move');
    $('.product-form__input').removeClass('move');
    $('.product_sns').removeClass('move');
    $('.limit_message').removeClass('move');
    $('.order_limit_message').removeClass('move');
  }
});
